import {PcLockr, utils} from 'util/'

const state = {
    cartList: [],
    invalidCartList: [],
    allCartLength: 0,
    orderStatusList: [
        {
            name: '未付款',
            value: 0
        },
        {
            name: '已付款',
            value: 1
        },
        {
            name: '已发货',
            value: 2
        },
        {
            name: '已签收',
            value: 3
        },
        {
            name: '退货申请',
            value: -1
        },
        {
            name: '退货中',
            value: -2
        },
        {
            name: '已退货',
            value: -3
        },
        {
            name: '取消交易',
            value: -4
        }
    ]
}

const getters = {
    getCartList(state) {
        return state.cartList || PcLockr.get('cartList')
    },
    getInvalidList(state) {
        return state.invalidCartList || PcLockr.get('invalidCartList')
    },
    getAllCartLength(state) {
        return state.allCartLength || PcLockr.get('allCartLength')
    },
    getOrderStatusList(state) {
        return state.orderStatusList
    }
}

const mutations = {
    cleatCartMsg(state) {
        PcLockr.set('cartList', [])
        PcLockr.set('invalidCartList', [])
        PcLockr.set('allCartLength', 0)
        state.cartList = []
        state.allCartLength = 0
        state.invalidCartList = []
    },
    // 设置购物车信息
    setCartList(state, data) {
        var cartList = []
        var invalidCartList = []
        data.forEach((item, index) => {
            if (item.skuCompose.sku && item.skuCompose.channelAttribute) {
                item.skuCompose.channelAttribute.canBuy = utils.getIfCanBuy(item.skuCompose.channelAttribute.buyMark)
                item.skuCompose.channelAttribute.buyMarkTitle = utils.getbuyMarkTitle(item.skuCompose.channelAttribute.buyMark)
                if (item.skuCompose.channelAttribute && item.skuCompose.channelAttribute.goodsState === 2 && item.skuCompose.channelAttribute.canBuy) {
                    cartList.push(item)
                } else {
                    invalidCartList.push(item)
                }
            }
        })
        state.cartList = cartList
        state.invalidCartList = invalidCartList
        state.allCartLength = cartList.length
        PcLockr.set('allCartLength', state.allCartLength)
        PcLockr.set('cartList', cartList)
        PcLockr.set('invalidCartList', invalidCartList)
    }
}

const actions = {
    setCartList({commit}, data) {
        commit('setCartList', data)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/cart/index.js